
export default {
  props:{
      race:{
          type: Object,
          required: true
      }
  },
  setup(){
    const style = 
    `
      background-image: url(img/circuit.png);
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
    `;
    return {style}
  }
}
